// Module
var code = "<div data-bind=\"geWindow: $data, header: 'Delete Grid Filter', modalSize: 'lg', align: true\" style=\"background-color:rgba(0,0,0,.5)\"> <div class=\"panel panel-primary\"> <div class=\"panel-body\" id=\"divOrderTemplatesPanel\"> <div id=\"deleteGridFiltersGrid\"></div> </div> </div> </div>";
// Exports
export default code;